const loginParams = '';
const activityId = 'HD0460171104225';
const applyDetail = {};
const activityUrl = 'http://www.koipy.com/igo/#/home';

const downloadActionUrl = 'https://icbc.rellux.com.cn/icbc-visa-website/apply/download';
export default {
    applyDetail: applyDetail,
    activityId: activityId,
    activityUrl: activityUrl,
    loginParams: loginParams,
    downloadActionUrl: downloadActionUrl
}


// WEBPACK FOOTER //
// ./src/common/config.js